<script>
  import { createEventDispatcher } from "svelte";
  import { clickOutside } from "svelte-utilities";
  import CaretDownIcon from "@local/assets/icons/caret-down.svg";
  import { profile } from "#src/stores/auth.js";

  export let value = "draft";
  export let disabled = false;

  const dispatch = createEventDispatcher();

  $: capabilities = $profile?.profile_capabilities?.capabilities || {};

  const statusColors = {
    "tally:unsubmitted": "oklch(70.4% 0.191 22.216)",
    "tally:pending": "oklch(70.4% 0.191 22.216)",
    "tally:draft": "oklch(64.8% 0.2 131.684)",
    "tally:blocked": "oklch(70.4% 0.191 22.216)",
    "tally:complete": "oklch(58.8% 0.158 241.966)",
    "tally:canceled": "oklch(70.7% 0.022 261.325)",
    draft: "oklch(76.8% 0.233 130.85)",
    flagged: "oklch(70.4% 0.191 22.216)",
    complete: "oklch(68.5% 0.169 237.323)",
  };

  const statusLabels = {
    "tally:unsubmitted": "Tally: Unsubmitted",
    "tally:pending": "Tally: Pending",
    "tally:draft": "Tally: Draft",
    "tally:blocked": "Tally: Awaiting Info",
    "tally:complete": "Tally: Complete",
    "tally:canceled": "Tally: Canceled",
    draft: "Draft",
    flagged: "Flagged",
    complete: "Complete",
  };

  let showMenu = false;

  function openMenu() {
    showMenu = !showMenu;
  }

  function selectStatus(value) {
    showMenu = false;
    dispatch("change", { value });
  }
</script>

<div
  class="uppercase border py-0.5 px-2 text-xs rounded-full flex gap-1"
  style="
    background-color: {statusColors[value]};
    border-color: {statusColors[value]};
    color: #fff;
  "
  use:clickOutside={[]}
  on:outclick={() => (showMenu = false)}>
  <div>
    {statusLabels[value]}
  </div>
  {#if !disabled}
    <button on:click={openMenu} class="relative">
      <CaretDownIcon />
    </button>
    {#if showMenu}
      <div class="absolute top-6 right-0 bg-white border rounded shadow-lg z-20 text-black p-2">
        {#if capabilities.edit_tally_jobs}
          <button class="dropdown-button-item" on:click={() => selectStatus("tally:pending")}>
            Tally: Pending
          </button>
          <button class="dropdown-button-item" on:click={() => selectStatus("tally:draft")}>
            Tally: Draft
          </button>
          <button class="dropdown-button-item" on:click={() => selectStatus("tally:blocked")}>
            Tally: Awaiting Info
          </button>
          <button class="dropdown-button-item" on:click={() => selectStatus("tally:complete")}>
            Tally: Complete
          </button>
          <button class="dropdown-button-item" on:click={() => selectStatus("tally:canceled")}>
            Tally: Canceled
          </button>
        {/if}
        <button class="dropdown-button-item" on:click={() => selectStatus("draft")}> Draft </button>
        <button class="dropdown-button-item" on:click={() => selectStatus("flagged")}> Flagged </button>
        <button class="dropdown-button-item" on:click={() => selectStatus("complete")}> Complete </button>
      </div>
    {/if}
  {/if}
</div>

<style lang="scss">
  .status-button {
    @apply w-full py-1 px-4 text-left text-gray-700 text-nowrap;

    &:hover {
      @apply bg-gray-100;
    }
  }
</style>
